import React from 'react';
import { valuesBand } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** Liturgical color of the season of each session (decorative): Ordinary Time green, Advent purple, Christmas gold,
 *  Lent purple, Holy Week / Easter gold-white. Same order as valuesBand.values. */
const seasons = ['#22A06B', '#22A06B', '#22A06B', '#22A06B', '#6D3FB5', '#F2B33D', '#22A06B', '#22A06B', '#6D3FB5', '#F2B33D'];

/** One faith word per session (with the color of its liturgical season) + the age levels every session adapts to */
export function ValuesBand() {
  return <section aria-labelledby="values-title" className="bg-ink py-12 md:py-16" data-id="element-264" data-mp="1e32ivv1sxp0n">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-265" data-mp="1e55cep25y0a4">
        <SectionHeading id="values-title" tone="dark" eyebrow={valuesBand.eyebrow} title={valuesBand.title} sub={valuesBand.sub} data-id="element-266" data-mp="1j2nepwlodh95" />

        <ol className="mx-auto mt-8 grid max-w-[980px] grid-cols-2 gap-2.5 sm:grid-cols-3 md:mt-10 md:grid-cols-5 md:gap-3" data-id="element-267" data-mp="2pkak67h5ip0l">
          {valuesBand.values.map((v, i) => <li key={v.n} className="overflow-hidden rounded-xl bg-white/[0.06] ring-1 ring-white/10" data-id="element-268" data-mp="160f39ncmff1r" data-mpi={i}>
              <span aria-hidden="true" className="block h-3 w-full" style={{
            background: seasons[i % seasons.length]
          }} data-id="element-269" data-mp="112dmxa6kxttz" />
              <div className="px-3.5 py-3" data-id="element-270" data-mp="x23dtonhqnaw">
                <p className="font-display text-[11px] font-extrabold tracking-[0.12em] text-sun" data-id="element-271" data-mp="s1yza46582nb">
                  {valuesBand.itemLabel} {v.n}
                </p>
                <p className="mt-0.5 font-display text-[17px] font-black uppercase leading-tight tracking-tight text-white" data-id="element-272" data-mp="ibcoqodaa2bh">{v.value}</p>
              </div>
            </li>)}
        </ol>

        <h3 className="mt-10 text-center font-display text-[13px] font-black tracking-[0.14em] text-sun" data-id="element-273" data-mp="9ao95p88rtwh">{valuesBand.agesTitle}</h3>
        <ul className="mx-auto mt-4 grid max-w-[980px] gap-3 md:grid-cols-3" data-id="element-274" data-mp="4butpr9e9sto">
          {valuesBand.ages.map(a => <li key={a.age} className="rounded-xl border border-white/10 bg-brand p-5" data-id="element-275" data-mp="3vj7eshdeeqev">
              <p className="inline-block rounded-md bg-coral px-2 py-1 font-display text-[12px] font-black tracking-[0.1em] text-white" data-id="element-276" data-mp="3lt8w552rzcuy">{a.age}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-white/85" data-id="element-277" data-mp="3qr0m3tjv0owi">{a.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}